<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-view ref="searchView" :scrId="scrId"></search-view>
				</sf-card>
			</div>
			<div class="sf-col sf-col-40">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-view ref="tableView" :scrId="scrId"></table-view>
				</sf-card>
			</div>
		</div>
	</div>
</template>

<script>
import SearchView from './Search/SearchView.vue';
import TableView from './Table/TableView.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {
		SearchView,
		TableView
	}
};
</script>
